<template>
  <div class="content">
    <div class="row align-center">
      <div class="large-11 columns">
        <h1 class="content__title heading">
          <div class="heading__start">
            <span>{{ $t('CONTRACT.TITLE') }} {{ contractStartDate }}</span>
            <span
              v-if="isNotAccepted"
              class="chip chip--warning chip--aligned-middle"
            >
              {{ $t('CONTRACT.NOT_ACCEPTED') }}
            </span>
            <span v-else class="chip chip--success chip--aligned-middle">
              {{ $t('CONTRACT.ACCEPTED') }}
            </span>
          </div>
        </h1>

        <div class="row align-justify">
          <div class="small-12 large-12 columns">
            <div class="contract raised">
              <div class="contract__body">
                <h2 v-show="contract[`changelog_${normalizedLang}`]">
                  {{ $t('CONTRACT.CHANGES') }}
                </h2>
                <div
                  v-dompurify-html="contract[`changelog_${normalizedLang}`]"
                />
                <div
                  v-dompurify-html="contract[`template_${normalizedLang}`]"
                />
              </div>
              <div class="contract__footer">
                <ElButton
                  v-if="
                    $auth.check(['publisher', 'changeFinanceInfo']) &&
                      isNotAccepted
                  "
                  type="primary"
                  size="large"
                  @click.native.prevent="acceptContract"
                >
                  {{ $t('CONTRACT.ACCEPT_BTN') }}
                </ElButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-jalaali';

import { Contract } from '@/api/api';

import { CONTRACT } from '@/store/types';
import modal from '@/mixins/modal';
import layout from '@/mixins/layout';
import lang from '@/mixins/lang';

const STATES = {
  ACCEPTED: 'ACCEPTED',
  NOT_ACCEPTED: 'NOT-ACCEPTED',
  NOT_ACCEPTED_BEFORE_DUE_DATE: 'NOT-ACCEPTED-BEFORE-DUE-DATE',
  NOT_ACCEPTED_AFTER_DUE_DATE: 'NOT-ACCEPTED-AFTER-DUE-DATE',
};

export default {
  mixins: [modal, layout, lang],

  data() {
    return {
      contract: {},
      visibility: false,
    };
  },

  computed: {
    isNotAccepted() {
      return (
        Object.hasOwnProperty.call(this.contract, 'state') &&
        this.contract.state !== STATES.ACCEPTED
      );
    },

    contractStartDate() {
      const startDate = this.contract.start_date || '';

      if (this.lang === 'fa' && startDate) {
        return moment(startDate).format('jYYYY/jMM/jDD');
      }

      return startDate
        .split('-')
        .reverse()
        .join('/');
    },
  },

  created() {
    this.setPageTitle('SETTINGS');

    this.getCurrentContract();
  },

  methods: {
    getCurrentContract() {
      return Contract.current()
        .then(({ body: { contract } }) => {
          this.contract = contract;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },

    acceptContract() {
      if (!this.$auth.check(['publisher', 'changeFinanceInfo'])) {
        return false;
      }

      return Contract.accept()
        .then(({ body: { message, contract } }) => {
          this.$store.dispatch(CONTRACT, 'ACCEPTED');
          this.contract = contract;
          this.$message.success(message);

          this.$router.push({
            name: 'apps',
          });
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.contract {
  margin-top: $global-margin;
  background-color: #fff;

  ul {
    list-style: none;
  }

  &,
  p {
    line-height: 2;
  }

  &__body {
    height: calc(100vh - 350px);
    overflow: auto;
    padding: $global-padding * 2 $global-padding $global-padding;

    @include breakpoint(small only) {
      height: calc(100vh - 250px);
    }

    @include breakpoint(medium only) {
      height: calc(100vh - 330px);
    }

    @include breakpoint(medium up) {
      min-height: 350px;
    }
  }

  &__footer {
    padding: $global-padding $global-padding $global-padding * 2;

    @include breakpoint(small only) {
      .el-button {
        display: block;
        width: 100%;
      }
    }
  }

  @include breakpoint(large) {
    &__body,
    &__footer {
      padding-left: $global-padding * 2;
      padding-right: $global-padding * 2;
    }
  }
}
</style>
